<template>
  <div class="w-100">
    <h3 class="mb-3" v-once>Kategori</h3>
    <span v-once
      >Silahkan memilih salah satu kategori data yang tersedia di bawah</span
    >

    <b-skeleton-wrapper :loading="loadingCategoryInput">
      <b-row class="mt-2 mx-0" align-v="center">
        <b-col class="p-0" cols="5">
          <b-skeleton type="input"></b-skeleton>
        </b-col>
        <b-col
          class="p-0"
          cols="1"
          style="display: flex !important; justify-content: center !important"
        >
          <b-skeleton type="button"></b-skeleton>
        </b-col>
        <b-col
          class="p-0"
          cols="1"
          style="display: flex !important; justify-content: center !important"
        >
          <b-skeleton type="button"></b-skeleton>
        </b-col>
      </b-row>
    </b-skeleton-wrapper>

    <b-form
      class="form-group-tabel-dinamis mt-2 py-0"
      v-show="loadingCategoryInput"
      inline
    >
      <b-form-select
        class="mr-1"
        v-model="selectedCategory"
        :select-size="1"
        style="width: 50%"
        :disabled="isLoadingAnOptions || isEditSelectedData"
      >
        <template #first>
          <b-form-select-option :value="null" disabled
            >-- Please select an option --</b-form-select-option
          >
        </template>

        <b-form-select-option
          v-for="option_category in optionsCategory"
          :value="option_category"
          :key="option_category.category"
          :title="option_category.category"
          >{{ option_category.category }}</b-form-select-option
        >
      </b-form-select>

      <b-button
        class="mx-1 td-btn-blue"
        :disabled="
          selectedCategory == null || isLoadingAnOptions || isEditSelectedData
        "
        @click="nextToDataset()"
        title="Melanjutkan ke opsi dataset"
        style="height: 34px !important"
      >
        Lanjut <b-icon icon="chevron-double-right" />
      </b-button>
    </b-form>
  </div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import services from "../../../../../services/TabelDinamisServicesV3";
import utils from "../../../../../utils/TabelDinamisUtils.js";
import store from "../../../../../store/TabelDinamisStoreV3.js";
import isUrl from "validator/lib/isURL";

//local registration for output component
export default {
  name: "CategorySelection",
  data() {
    return {
      isCategoryMetadata: false,
      isCategoryNextClicked: false,
      optionsCategory: "",
      selectedCategory: null,
      selectedCategoryDescription: "-",
      selectedCategoryName: "-",
      selectedCategoryReference: "-",
    };
  },
  props: [
    "projectName",
    "originalOptionsCategory",
    "originalSelectedCategory",
    "originalIsCategoryNextClicked",
    "isLoadingAnOptions",
    "isClearAllLocalStorage",
    "isEditSelectedData",
    "idxSelectedData",
  ],
  created() {},
  destroyed() {},
  mounted: function () {
    let statusCategoryOptionsLocalStorage =
      store.precheckCategoryOptionsLocalStorage();

    switch (statusCategoryOptionsLocalStorage) {
      case "expired":
      case "not-set":
        this.loadCategory();
        break;
      case "alive":
        setTimeout(
          function () {
            this.optionsCategory = JSON.parse(
              store.getSelectionLocalStorageByKey("category")
            ).items;
          }.bind(this),
          200
        );

        break;
    }
  },
  computed: {
    loadingCategoryInput: function () {
      if (this.optionsCategory == "") {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    selectedCategory: {
      handler: function (val) {
        // console.log(val);
        if (val == null) {
          this.selectedCategoryDescription = "-";
          this.selectedCategory = "-";
          this.selectedCategoryReference = "-";

          this.isCategoryNextClicked = false;
        } else {
          // console.log(val);
          this.selectedCategoryName = utils.changeNullIntoStrip(
            this.selectedCategory.category
          );
          // console.log(this.selectedCategory.name);
          // // this.selectedCategoryDescription = utils.changeNullIntoStrip(
          // //   this.selectedCategory.description
          // // );
          // // this.selectedCategoryReference = utils.changeNullIntoStrip(
          // //   this.selectedCategory.reference
          // // );
          if (this.isEditSelectedData) {
            this.nextToDataset();
          } else {
            this.isCategoryNextClicked = false;
          }
        }
        // console.log("sandy emit");
        // console.log(val);
        this.$emit("update:originalSelectedCategory", val);
      },
      immediate: true,
    },
    optionsCategory: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit("update:originalOptionsCategory", newVal);
        }
      },
      immediate: true,
    },
    isCategoryNextClicked: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit(
            "update:originalIsCategoryNextClicked",
            this.isCategoryNextClicked
          );
        }
      },
      immediate: true,
    },
    isClearAllLocalStorage: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal) {
            this.loadCategory();
          }
        }
      },
    },
    originalOptionsCategory: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.optionsCategory = newVal;
        }
      },
    },
    originalSelectedCategory: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.selectedCategory = newVal;
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadCategory() {
      this.$emit("update:isLoadingAnOptions", true);
      this.optionsCategory = "";
      this.selectedCategory = null;

      await services.getCategoryByProject(this.projectName).then(
        (response) => {
          // console.log(response);
          this.optionsCategory = response.data.dataList;
          utils.sortArrayByStringProperty(this.optionsCategory, "category");

          store.updateSelectionLocalStorage("category", this.optionsCategory);

          this.$emit("update:isClearAllLocalStorage", false);
          this.$emit("update:isLoadingAnOptions", false);
        },
        () => {
          /* this.data =
						(error.response && error.response.data) ||
						error.message ||
						error.toString(); */
        }
      );
    },
    nextToDataset() {
      if (this.selectedCategory != null) {
        utils.scrollIntoDiv("tabel-dinamis-progress-stepper-dataset");
        this.isCategoryNextClicked = true;
      }
    },
    isUrl(val) {
      return isUrl(val);
    },
  },
  components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 25-04-2022 -->
